<template>
  <transition name="slide-fast">
    <div
      v-if="isDisplayed"
      class="edition-modal"
      :class="elClasses"
      :style="editionModalStyle"
    >
      <slot />
    </div>
  </transition>
</template>

<script>
/**
 * Edition modal template.
 *
 * @vue-prop {String} queryParam - Query parameter used to display the modal
 *                                 Also used in the state to determine which modal is the highest.
 * @vue-prop {Boolean} [notAsPage] - Set to true if this modal isn't in the generic modal process
 *                                   (stacking modals above each other). If this component is used
 *                                   to display generic content within another page, set this prop to true.
 */

import { mapMutations } from 'vuex';
import { INCREASE_EDITION_MODAL_INDEX, RESET_EDITION_MODAL_INDEX } from '@/store/mutation-types';


export default {

  name: 'EditionModal',

  props: {
    queryParam: {
      type: String,
      required: true,
    },
    notAsPage: Boolean,
    isDisplayed: Boolean,
  },

  computed: {
    /** Object: Classes applied to this.$el */
    elClasses() {
      return {
        'edition-modal--not-as-page': this.notAsPage,
        'edition-modal--in-embedded-app': this.appEmbedded,
      };
    },
    /** Object: CSS style */
    editionModalStyle() {
      return {
        zIndex: this.notAsPage ? undefined : this.$store.state.editionModalsZIndexes[this.queryParam] || 1,
      };
    },
  },

  watch: {
    isDisplayed() {
      if (!this.notAsPage) {
        if (this.isDisplayed) {
          this.INCREASE_EDITION_MODAL_INDEX(this.queryParam);
        } else {
          this.RESET_EDITION_MODAL_INDEX(this.queryParam);
        }
      }
    },
  },

  mounted() {
    if (this.isDisplayed && !this.notAsPage) {
      this.INCREASE_EDITION_MODAL_INDEX(this.queryParam);
    }
  },

  methods: {
    ...mapMutations({
      INCREASE_EDITION_MODAL_INDEX,
      RESET_EDITION_MODAL_INDEX,
    }),
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.edition-modal {
  background: $color-body-background;
  position: fixed;
  top: $header-height;
  left: $nav-width;
  height: calc(100% - #{$header-height});
  width: calc(100% - #{$nav-width});

  &--not-as-page {
    position: static;
    width: 100%;
    height: 100%;
  }

  &--in-embedded-app {
    left: 0px;
    width: 100%;
  }
}

@media (max-width: $smartphone-landscape) {
  .edition-modal {
    top: $smartphone-header-height;
    left: #{$smartphone-nav-width};
    height: calc(100% - #{$smartphone-header-height});
    width: calc(100% - #{$smartphone-nav-width});
  }
}
</style>
